export default __webpack_public_path__ + "88c765818924a265b5b8fa3c598743ab.png";